var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABR0lEQVR4Ae3VAWTDQBiG4aI4FAUUAAXAUMAwhgKGooChKIYCCgiKAYJhgKEoigIGgGAICgiGIAigKIrh34uhwrn+ySVh7csDwBe5XDq3rqU7BNjhC+mfCFssMUStdbFABrlQgmd47wnfkJL2uIeXAogHP5hVfUVbiGchSrWC1GQGVVOIQooXjGBwluX1Kc6UQa4Ys0YPtsRiX8chTmBA6kFwXwkGB8WgMRw5HsjRI0TBoNgDgjPiMIS1d4hCsQlEaQlrccVBAURpC2tZC4MiWJMWBqXVBukThwzWDi0MimEtaWHQJ6x9tDAoqPpTDQC4LkVAHEaw1sexwa8sg7OwwUELOBvg2MCgHAYXNW9g0BiqNjUOeoU6g6iGQRt0Uaoedh4HhfDSHKcKgzJM4LUBQpwUg3Ks0Edt9TDFGsWWiPGGCbqd/96tX+rAIKC5wnoQAAAAAElFTkSuQmCC"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "baseline_facebook_black_18dp",
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#pattern)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2db12fdadec984f6e26fd57da210751a.svg";
export { ForwardRef as ReactComponent };